module.exports = __webpack_public_path__ + "img/doc.cf67bf7e.svg";